import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import success from '../Assets/success.png';
import { API_BASE_URL } from '../config';

const Success = () => {
  const location = useLocation();
  const { amount, name, orderId, search = '', backTo } = location.state || {};

  const handleDownloadReceipt = async () => {
    try {
      const response = await fetch(
        `https://laravel-file-gen-production.up.railway.app/download-receipt_from_order/${orderId}`
      );

      if (!response.ok) {
        await fetch(
          `${API_BASE_URL}/api/v1/dms/whatsapp_receipt_when_web_download_fails?order_id=${orderId}`
        ).catch(() => {});
        alert('Receipt could not be downloaded. It will be sent to your WhatsApp.');
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `receipt-${orderId}-${name.replace(/\s+/g, '-')}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Receipt download error:', error);
      alert('Failed to download receipt. Please try again.');
    }
  };

  return (
    <div className='success-bg'>
      <div className="content-status">
        <img src={success} className='successimage' alt="Payment successful" />
        <h1 className='payment-text'>Payment Successful!</h1>
        <div className='payment-details'>
          <p className='payment-sub'>Thank you for your donation, {name}!</p>
          <p className='payment-amount'>₹{amount}</p>
          <p className='order-id'>Order ID: {orderId}</p>
        </div>
        <div className='button-container'>
          <button
            onClick={handleDownloadReceipt}
            className='btn-recipt'
            disabled={!orderId}
          >
            <i className="ri-printer-line"></i>
            Download Receipt
          </button>
          <Link to={backTo || `/${search}`} className='btn-try'>Back Home</Link>
        </div>
      </div>
    </div>
  );
};

export default Success;
